import React, { createContext, useContext, useEffect } from "react";
import S from "./seoStatic.json";

const dict = {
  it: {
    "nav.home": "Home",
    "nav.expeditions": "Spedizioni",
    "nav.destinations": "Destinazioni",
    "dest.eyebrow": "Dove andiamo",
    "dest.title": "Destinazioni",
    "dest.intro": "I territori in cui operiamo davvero: ogni destinazione raccoglie le spedizioni aperte, le guide che le accompagnano e le coordinate esatte del luogo.",
    "dest.oneTrip": "spedizione",
    "dest.manyTrips": "spedizioni",
    "dest.tripsHere": "Spedizioni in questa destinazione",
    "dest.leadersHere": "Chi ti accompagna qui",
    "dest.empty": "Nessuna destinazione disponibile al momento.",
    "dest.seoSuffix": "spedizioni e viaggi | De Los Cielos",
    "dest.linkFromTour": "Scopri la destinazione",
    "seo.dest.title": S.it["/destinazioni"].title,
    "seo.dest.desc": S.it["/destinazioni"].description,
    "nav.leaders": "Tour Leader",
    "nav.contact": "Contatti",
    "nav.area": "Area Riservata",
    "hero.eyebrow": "Esperienze trasformative · Viaggi spirituali · Esplorazioni in terre remote",
    "hero.line1": "Dove il cielo",
    "hero.line2": "tocca la terra.",
    "hero.sub": "Spedizioni d'autore in Amazzonia, deserto del Sonora, Chapada Diamantina e Ruanda. Piccoli gruppi, guide d'eccezione, nessuna fretta.",
    "hero.cta1": "Esplora le spedizioni",
    "hero.cta2": "Guarda il film",
    "hero.destinations": ["AMAZZONIA — 3°S 73°W", "DESERTO DEL SONORA — 29°N 111°W", "CHAPADA DIAMANTINA — 12°S 41°W", "RUANDA — 1°S 29°E"],
    "hero.scroll": "Scorri per esplorare",
    "manifesto.eyebrow": "Il nostro manifesto",
    "manifesto.title": "Quattro principi, una sola direzione",
    "manifesto.others": "Gli altri principi",
    "seo.home.title": S.it["/"].title,
    "seo.home.desc": S.it["/"].description,
    "seo.tours.title": S.it["/viaggi"].title,
    "seo.tours.desc": S.it["/viaggi"].description,
    "seo.leaders.title": S.it["/leader"].title,
    "seo.leaders.desc": S.it["/leader"].description,
    "seo.contact.title": S.it["/contatti"].title,
    "seo.contact.desc": S.it["/contatti"].description,
    "seo.apply.title": S.it["/candidatura"].title,
    "seo.apply.desc": S.it["/candidatura"].description,
    "seo.privacy.title": S.it["/privacy"].title,
    "seo.privacy.desc": S.it["/privacy"].description,
    "seo.cookie.title": S.it["/cookie-policy"].title,
    "seo.cookie.desc": S.it["/cookie-policy"].description,
    "nav.about": "Chi siamo",
    "nav.faq": "FAQ",
    "about.eyebrow": "Chi siamo",
    "about.ctaTours": "Le spedizioni aperte",
    "about.ctaLeaders": "I tour leader",
    "about.ctaFaq": "Domande frequenti",
    "faq.eyebrow": "Domande frequenti",
    "faq.stillEyebrow": "Non hai trovato la risposta?",
    "faq.stillTitle": "Scrivici: risponde una persona, non un modulo.",
    "faq.stillText": "Raccontaci cosa ti serve sapere sulla spedizione che stai valutando: leggiamo tutto e rispondiamo entro 48 ore.",
    "faq.stillCta": "Vai ai contatti",
    "seo.about.title": S.it["/chi-siamo"].title,
    "seo.about.desc": S.it["/chi-siamo"].description,
    "seo.faq.title": S.it["/faq"].title,
    "seo.faq.desc": S.it["/faq"].description,
    "seo.leader.fallback": "{name} è {role} di De Los Cielos e accompagna spedizioni in piccoli gruppi in {territory}: percorso, territori e filosofia di viaggio della guida.",
    "contact.waMessage": "Ciao De Los Cielos, vorrei informazioni sulle prossime spedizioni.",
    "manifesto.1.title": "Sostenibilità",
    "manifesto.1.text": "Attraversiamo i luoghi in punta di piedi: gruppi ridotti, ritmi lenti, risorse condivise con chi ci accoglie. Ogni spedizione lascia il territorio come l'ha trovato, o più forte.",
    "manifesto.2.title": "Sincretismo Culturale",
    "manifesto.2.text": "Dove le tradizioni si incontrano nascono nuovi significati. Camminiamo accanto a comunità, custodi e saperi antichi, imparando a leggere il mondo con più di uno sguardo.",
    "manifesto.3.title": "Riconnessione con la natura",
    "manifesto.3.text": "Oltre il segnale del telefono la foresta respira e il deserto ascolta. Torniamo a un tempo che segue il sole, l'acqua e il silenzio: là ritroviamo la misura di noi stessi.",
    "manifesto.4.title": "Esperienza trasformativa / Spirituale",
    "manifesto.4.text": "Non si torna uguali. Ogni viaggio è un rito di passaggio: cerimonie, ascolto e paesaggi che aprono uno spazio interiore e lo lasciano più vasto di prima.",
    "home.exped.eyebrow": "Le spedizioni",
    "home.exped.title": "Prossime partenze",
    "home.exped.cta": "Tutte le spedizioni",
    "home.leaders.eyebrow": "I protagonisti",
    "home.leaders.title": "Tour Leader",
    "home.leaders.cta": "Tutti i leader",
    "home.audio.eyebrow": "Diari sonori",
    "home.audio.title": "La spedizione si ascolta",
    "home.cta.title": "Scopriamo assieme se questa esperienza è adatta a te",
    "home.cta.sub": "Raccontaci le tue esperienze pregresse, cosa desideri e cosa vuoi scoprire di te e del mondo viaggiando. Rispondi ad alcune domande per permetterci di capire quale esperienza può realizzare i tuoi desideri.",
    "home.cta.btn": "Rispondi alle domande",
    "tours.eyebrow": "Catalogo",
    "tours.title": "Spedizioni",
    "tours.sub": "Ogni viaggio nasce da un sondaggio in loco e si ripete solo finché resta vero.",
    "tours.program": "Il programma giorno per giorno",
    "tours.gallery": "Dalle edizioni precedenti",
    "tours.stories": "Storie dal campo",
    "tours.included": "Nel prezzo",
    "tours.excluded": "Non incluso",
    "tours.leader": "Guide della spedizione",
    "tours.cta": "Chiedi di partecipare",
    "apply.eyebrow": "Candidature",
    "apply.title": "Chiedi di partecipare",
    "apply.sub": "Nessun pagamento online: raccontaci chi sei, valutiamo ogni candidatura a mano e ti rispondiamo entro 48 ore.",
    "apply.tour": "Spedizione",
    "apply.fieldsTitle": "La tua candidatura",
    "apply.step1": "Compila il modulo della spedizione che ti interessa.",
    "apply.step2": "Il Tour Leader leggerà personalmente tutte le richieste.",
    "apply.step3": "Verrai ricontattato entro 48 ore per un feedback diretto.",
    "apply.consent": "Acconsento a essere contattato in merito alla mia candidatura *",
    "apply.submit": "Invia la candidatura",
    "apply.successTitle": "Candidatura ricevuta.",
    "apply.successText": "È arrivata alla nostra base. La leggiamo con attenzione: risposta entro 48 ore.",
    "apply.again": "Invia un'altra candidatura",
    "tours.days": "giorni",
    "tours.group": "gruppo max",
    "tours.from": "da",
    "badge.available": "Posti disponibili",
    "badge.last_spots": "Ultimi posti",
    "badge.sold_out": "Sold out",
    "contact.eyebrow": "Contatti",
    "contact.title": "Scrivici per costruire assieme l'esperienza giusta per te",
    "contact.sub": "Rispondiamo entro 48 ore, con proposte reali e date vere. Nessuna newsletter, nessuno spam.",
    "contact.name": "Nome e cognome *",
    "contact.email": "Email *",
    "contact.phone": "Telefono / WhatsApp",
    "contact.destination": "Destinazione d'interesse",
    "contact.destOther": "Altro / devo ancora scegliere",
    "contact.budget": "Budget a persona",
    "contact.message": "Raccontaci la tua filosofia di viaggio e l'esperienza che desideri",
    "contact.submit": "Invia la richiesta",
    "contact.successTitle": "Richiesta ricevuta.",
    "contact.successText": "È arrivata alla nostra base. Torniamo verso di te entro 48 ore con una proposta su misura.",
    "contact.again": "Invia un'altra richiesta",
    "budget.any": "Non lo so ancora",
    "budget.b1": "Fino a €2.000",
    "budget.b2": "€2.000 — €3.000",
    "budget.b3": "€3.000 — €4.000",
    "budget.b4": "Oltre €4.000",
    "footer.tagline": "Spedizioni d'autore ai confini del mondo.",
    "footer.nav": "Navigazione",
    "footer.contact": "Contatti",
    "footer.rights": "Tutti i diritti riservati.",
    "legal.privacy": "Privacy Policy",
    "legal.cookie": "Cookie Policy",
    "legal.preferences": "Preferenze cookie",
    "cookie.text": "Usiamo cookie tecnici necessari al funzionamento del sito e, solo con il tuo consenso, strumenti di statistica per capire come viene usato. Puoi cambiare idea in ogni momento.",
    "cookie.accept": "Accetta",
    "cookie.reject": "Rifiuta",
    "consent.pre": "Ho letto e accetto il trattamento dei miei dati come descritto nella",
    "consent.link": "Privacy Policy",
    "past.title": "Gallery",
    "past.photos": "Foto",
    "past.videos": "Video",
    "past.audio": "Audio",
    "leader.media.title": "Galleria e media",
  },
  en: {
    "nav.home": "Home",
    "nav.expeditions": "Expeditions",
    "nav.destinations": "Destinations",
    "dest.eyebrow": "Where we go",
    "dest.title": "Destinations",
    "dest.intro": "The territories we actually travel: each destination gathers the open expeditions, the guides who lead them and the exact coordinates of the place.",
    "dest.oneTrip": "expedition",
    "dest.manyTrips": "expeditions",
    "dest.tripsHere": "Expeditions in this destination",
    "dest.leadersHere": "Who guides you here",
    "dest.empty": "No destination available at the moment.",
    "dest.seoSuffix": "expeditions and journeys | De Los Cielos",
    "dest.linkFromTour": "Explore the destination",
    "seo.dest.title": S.en["/destinazioni"].title,
    "seo.dest.desc": S.en["/destinazioni"].description,
    "nav.leaders": "Tour Leaders",
    "nav.contact": "Contact",
    "nav.area": "Reserved Area",
    "hero.eyebrow": "Transformative experiences · Spiritual journeys · Explorations in remote lands",
    "hero.line1": "Where the sky",
    "hero.line2": "touches the earth.",
    "hero.sub": "Author expeditions in the Amazon, the Sonoran Desert, Chapada Diamantina and Rwanda. Small groups, exceptional guides, no rush.",
    "hero.cta1": "Explore the expeditions",
    "hero.cta2": "Watch the film",
    "hero.destinations": ["AMAZON — 3°S 73°W", "SONORAN DESERT — 29°N 111°W", "CHAPADA DIAMANTINA — 12°S 41°W", "RWANDA — 1°S 29°E"],
    "hero.scroll": "Scroll to explore",
    "manifesto.eyebrow": "Our manifesto",
    "manifesto.title": "Four principles, one direction",
    "manifesto.others": "The other principles",
    "seo.home.title": S.en["/"].title,
    "seo.home.desc": S.en["/"].description,
    "seo.tours.title": S.en["/viaggi"].title,
    "seo.tours.desc": S.en["/viaggi"].description,
    "seo.leaders.title": S.en["/leader"].title,
    "seo.leaders.desc": S.en["/leader"].description,
    "seo.contact.title": S.en["/contatti"].title,
    "seo.contact.desc": S.en["/contatti"].description,
    "seo.apply.title": S.en["/candidatura"].title,
    "seo.apply.desc": S.en["/candidatura"].description,
    "seo.privacy.title": S.en["/privacy"].title,
    "seo.privacy.desc": S.en["/privacy"].description,
    "seo.cookie.title": S.en["/cookie-policy"].title,
    "seo.cookie.desc": S.en["/cookie-policy"].description,
    "nav.about": "About us",
    "nav.faq": "FAQ",
    "about.eyebrow": "About us",
    "about.ctaTours": "Open expeditions",
    "about.ctaLeaders": "The tour leaders",
    "about.ctaFaq": "Frequently asked questions",
    "faq.eyebrow": "Frequently asked questions",
    "faq.stillEyebrow": "Didn't find your answer?",
    "faq.stillTitle": "Write to us: a person replies, not a form.",
    "faq.stillText": "Tell us what you need to know about the expedition you are considering: we read everything and reply within 48 hours.",
    "faq.stillCta": "Go to contacts",
    "seo.about.title": S.en["/chi-siamo"].title,
    "seo.about.desc": S.en["/chi-siamo"].description,
    "seo.faq.title": S.en["/faq"].title,
    "seo.faq.desc": S.en["/faq"].description,
    "seo.leader.fallback": "{name} is {role} at De Los Cielos and leads small-group expeditions in {territory}: the guide's path, territories and travel philosophy.",
    "contact.waMessage": "Hello De Los Cielos, I would like information about the upcoming expeditions.",
    "manifesto.1.title": "Sustainability",
    "manifesto.1.text": "We cross places on tiptoe: small groups, slow rhythms, resources shared with those who host us. Every expedition leaves the land as it found it, or stronger.",
    "manifesto.2.title": "Cultural Syncretism",
    "manifesto.2.text": "Where traditions meet, new meanings are born. We walk beside communities, guardians and ancient knowledge, learning to read the world with more than one gaze.",
    "manifesto.3.title": "Reconnection with nature",
    "manifesto.3.text": "Beyond the phone signal the forest breathes and the desert listens. We return to a time that follows the sun, the water and the silence: there we find our own measure again.",
    "manifesto.4.title": "Transformative / Spiritual experience",
    "manifesto.4.text": "No one returns the same. Every journey is a rite of passage: ceremonies, listening and landscapes that open an inner space and leave it wider than before.",
    "home.exped.eyebrow": "The expeditions",
    "home.exped.title": "Next departures",
    "home.exped.cta": "All expeditions",
    "home.leaders.eyebrow": "The protagonists",
    "home.leaders.title": "Tour Leaders",
    "home.leaders.cta": "All leaders",
    "home.audio.eyebrow": "Sound diaries",
    "home.audio.title": "The expedition, listened to",
    "home.cta.title": "Let's find out together if this experience is right for you",
    "home.cta.sub": "Tell us about your past experiences, what you desire and what you want to discover about yourself and the world by travelling. Answer a few questions so we can understand which experience can fulfil your wishes.",
    "home.cta.btn": "Answer the questions",
    "tours.eyebrow": "Catalogue",
    "tours.title": "Expeditions",
    "tours.sub": "Every journey starts with field scouting and repeats only as long as it stays true.",
    "tours.program": "The day-by-day program",
    "tours.gallery": "From previous editions",
    "tours.stories": "Stories from the field",
    "tours.included": "In the price",
    "tours.excluded": "Not included",
    "tours.leader": "Expedition guides",
    "tours.cta": "Request to join",
    "apply.eyebrow": "Applications",
    "apply.title": "Request to join",
    "apply.sub": "No online payment: tell us who you are, we review every application by hand and reply within 48 hours.",
    "apply.tour": "Expedition",
    "apply.fieldsTitle": "Your application",
    "apply.step1": "Fill in the form of the expedition you are interested in.",
    "apply.step2": "The Tour Leader will personally read every application.",
    "apply.step3": "You will be contacted within 48 hours with direct feedback.",
    "apply.consent": "I consent to being contacted about my application *",
    "apply.submit": "Send application",
    "apply.successTitle": "Application received.",
    "apply.successText": "It reached our base. We read every application with care: reply within 48 hours.",
    "apply.again": "Send another application",
    "tours.days": "days",
    "tours.group": "max group",
    "tours.from": "from",
    "badge.available": "Spots available",
    "badge.last_spots": "Last spots",
    "badge.sold_out": "Sold out",
    "contact.eyebrow": "Contact",
    "contact.title": "Write to us and we'll build the right experience for you",
    "contact.sub": "We reply within 48 hours, with real proposals and true dates. No newsletter, no spam.",
    "contact.name": "Full name *",
    "contact.email": "Email *",
    "contact.phone": "Phone / WhatsApp",
    "contact.destination": "Destination of interest",
    "contact.destOther": "Other / still deciding",
    "contact.budget": "Budget per person",
    "contact.message": "Tell us about your travel philosophy and the experience you want",
    "contact.submit": "Send request",
    "contact.successTitle": "Request received.",
    "contact.successText": "It reached our base camp. We'll get back to you within 48 hours with a tailored proposal.",
    "contact.again": "Send another request",
    "budget.any": "Not sure yet",
    "budget.b1": "Up to €2,000",
    "budget.b2": "€2,000 — €3,000",
    "budget.b3": "€3,000 — €4,000",
    "budget.b4": "Above €4,000",
    "footer.tagline": "Author expeditions at the edge of the world.",
    "footer.nav": "Navigation",
    "footer.contact": "Contact",
    "footer.rights": "All rights reserved.",
    "legal.privacy": "Privacy Policy",
    "legal.cookie": "Cookie Policy",
    "legal.preferences": "Cookie preferences",
    "cookie.text": "We use technical cookies required for the site to work and, only with your consent, analytics tools to understand how it is used. You can change your mind at any time.",
    "cookie.accept": "Accept",
    "cookie.reject": "Decline",
    "consent.pre": "I have read and accept the processing of my data as described in the",
    "consent.link": "Privacy Policy",
    "past.title": "Gallery",
    "past.photos": "Photos",
    "past.videos": "Videos",
    "past.audio": "Audio",
    "leader.media.title": "Gallery & media",
  },
  es: {
    "nav.home": "Inicio",
    "nav.expeditions": "Expediciones",
    "nav.destinations": "Destinos",
    "dest.eyebrow": "Dónde vamos",
    "dest.title": "Destinos",
    "dest.intro": "Los territorios en los que viajamos de verdad: cada destino reúne las expediciones abiertas, las guías que las acompañan y las coordenadas exactas del lugar.",
    "dest.oneTrip": "expedición",
    "dest.manyTrips": "expediciones",
    "dest.tripsHere": "Expediciones en este destino",
    "dest.leadersHere": "Quién te acompaña aquí",
    "dest.empty": "Ningún destino disponible por el momento.",
    "dest.seoSuffix": "expediciones y viajes | De Los Cielos",
    "dest.linkFromTour": "Descubre el destino",
    "seo.dest.title": S.es["/destinazioni"].title,
    "seo.dest.desc": S.es["/destinazioni"].description,
    "nav.leaders": "Guías",
    "nav.contact": "Contacto",
    "nav.area": "Área Reservada",
    "hero.eyebrow": "Experiencias transformadoras · Viajes espirituales · Exploraciones en tierras remotas",
    "hero.line1": "Donde el cielo",
    "hero.line2": "toca la tierra.",
    "hero.sub": "Expediciones de autor en la Amazonia, el desierto de Sonora, Chapada Diamantina y Ruanda. Grupos pequeños, guías excepcionales, ninguna prisa.",
    "hero.cta1": "Explora las expediciones",
    "hero.cta2": "Mira la película",
    "hero.destinations": ["AMAZONIA — 3°S 73°W", "DESIERTO DE SONORA — 29°N 111°W", "CHAPADA DIAMANTINA — 12°S 41°W", "RUANDA — 1°S 29°E"],
    "hero.scroll": "Desliza para explorar",
    "manifesto.eyebrow": "Nuestro manifiesto",
    "manifesto.title": "Cuatro principios, una sola dirección",
    "manifesto.others": "Los otros principios",
    "seo.home.title": S.es["/"].title,
    "seo.home.desc": S.es["/"].description,
    "seo.tours.title": S.es["/viaggi"].title,
    "seo.tours.desc": S.es["/viaggi"].description,
    "seo.leaders.title": S.es["/leader"].title,
    "seo.leaders.desc": S.es["/leader"].description,
    "seo.contact.title": S.es["/contatti"].title,
    "seo.contact.desc": S.es["/contatti"].description,
    "seo.apply.title": S.es["/candidatura"].title,
    "seo.apply.desc": S.es["/candidatura"].description,
    "seo.privacy.title": S.es["/privacy"].title,
    "seo.privacy.desc": S.es["/privacy"].description,
    "seo.cookie.title": S.es["/cookie-policy"].title,
    "seo.cookie.desc": S.es["/cookie-policy"].description,
    "nav.about": "Quiénes somos",
    "nav.faq": "FAQ",
    "about.eyebrow": "Quiénes somos",
    "about.ctaTours": "Las expediciones abiertas",
    "about.ctaLeaders": "Los tour leaders",
    "about.ctaFaq": "Preguntas frecuentes",
    "faq.eyebrow": "Preguntas frecuentes",
    "faq.stillEyebrow": "¿No encuentras la respuesta?",
    "faq.stillTitle": "Escríbenos: responde una persona, no un formulario.",
    "faq.stillText": "Cuéntanos qué necesitas saber sobre la expedición que estás valorando: lo leemos todo y respondemos en 48 horas.",
    "faq.stillCta": "Ir a contacto",
    "seo.about.title": S.es["/chi-siamo"].title,
    "seo.about.desc": S.es["/chi-siamo"].description,
    "seo.faq.title": S.es["/faq"].title,
    "seo.faq.desc": S.es["/faq"].description,
    "seo.leader.fallback": "{name} es {role} de De Los Cielos y acompaña expediciones en grupos pequeños en {territory}: recorrido, territorios y filosofía de viaje de la guía.",
    "contact.waMessage": "Hola De Los Cielos, quisiera información sobre las próximas expediciones.",
    "manifesto.1.title": "Sostenibilidad",
    "manifesto.1.text": "Atravesamos los lugares de puntillas: grupos reducidos, ritmos lentos, recursos compartidos con quienes nos acogen. Cada expedición deja el territorio como lo encontró, o más fuerte.",
    "manifesto.2.title": "Sincretismo Cultural",
    "manifesto.2.text": "Donde las tradiciones se encuentran nacen nuevos significados. Caminamos junto a comunidades, guardianes y saberes antiguos, aprendiendo a leer el mundo con más de una mirada.",
    "manifesto.3.title": "Reconexión con la naturaleza",
    "manifesto.3.text": "Más allá de la señal del teléfono el bosque respira y el desierto escucha. Volvemos a un tiempo que sigue al sol, al agua y al silencio: allí reencontramos nuestra propia medida.",
    "manifesto.4.title": "Experiencia transformadora / Espiritual",
    "manifesto.4.text": "Nadie vuelve igual. Cada viaje es un rito de paso: ceremonias, escucha y paisajes que abren un espacio interior y lo dejan más amplio que antes.",
    "home.exped.eyebrow": "Las expediciones",
    "home.exped.title": "Próximas salidas",
    "home.exped.cta": "Todas las expediciones",
    "home.leaders.eyebrow": "Los protagonistas",
    "home.leaders.title": "Guías",
    "home.leaders.cta": "Todos los guías",
    "home.audio.eyebrow": "Diarios sonoros",
    "home.audio.title": "La expedición se escucha",
    "home.cta.title": "Descubramos juntos si esta experiencia es para ti",
    "home.cta.sub": "Cuéntanos tus experiencias previas, qué deseas y qué quieres descubrir de ti y del mundo viajando. Responde a algunas preguntas para que podamos entender qué experiencia puede realizar tus deseos.",
    "home.cta.btn": "Responde a las preguntas",
    "tours.eyebrow": "Catálogo",
    "tours.title": "Expediciones",
    "tours.sub": "Cada viaje nace de un reconocimiento en el terreno y se repite solo mientras sigue siendo verdadero.",
    "tours.program": "El programa día a día",
    "tours.gallery": "De las ediciones anteriores",
    "tours.stories": "Historias de campo",
    "tours.included": "En el precio",
    "tours.excluded": "No incluido",
    "tours.leader": "Guías de la expedición",
    "tours.cta": "Solicita participar",
    "apply.eyebrow": "Candidaturas",
    "apply.title": "Solicita participar",
    "apply.sub": "Sin pago en línea: cuéntanos quién eres, evaluamos cada candidatura a mano y respondemos en 48 horas.",
    "apply.tour": "Expedición",
    "apply.fieldsTitle": "Tu candidatura",
    "apply.step1": "Rellena el formulario de la expedición que te interesa.",
    "apply.step2": "El Tour Leader leerá personalmente todas las solicitudes.",
    "apply.step3": "Te contactaremos en un plazo de 48 horas con una respuesta directa.",
    "apply.consent": "Doy mi consentimiento para ser contactado sobre mi candidatura *",
    "apply.submit": "Enviar candidatura",
    "apply.successTitle": "Candidatura recibida.",
    "apply.successText": "Llegó a nuestra base. La leemos con atención: respuesta en 48 horas.",
    "apply.again": "Enviar otra candidatura",
    "tours.days": "días",
    "tours.group": "grupo máx.",
    "tours.from": "desde",
    "badge.available": "Plazas disponibles",
    "badge.last_spots": "Últimas plazas",
    "badge.sold_out": "Agotado",
    "contact.eyebrow": "Contacto",
    "contact.title": "Escríbenos para construir juntos la experiencia adecuada para ti",
    "contact.sub": "Respondemos en 48 horas, con propuestas reales y fechas verdaderas. Sin newsletter, sin spam.",
    "contact.name": "Nombre completo *",
    "contact.email": "Email *",
    "contact.phone": "Teléfono / WhatsApp",
    "contact.destination": "Destino de interés",
    "contact.destOther": "Otro / aún lo estoy decidiendo",
    "contact.budget": "Presupuesto por persona",
    "contact.message": "Cuéntanos tu filosofía de viaje y la experiencia que deseas",
    "contact.submit": "Enviar solicitud",
    "contact.successTitle": "Solicitud recibida.",
    "contact.successText": "Llegó a nuestra base. Te escribimos de vuelta en 48 horas con una propuesta a medida.",
    "contact.again": "Enviar otra solicitud",
    "budget.any": "Todavía no lo sé",
    "budget.b1": "Hasta €2.000",
    "budget.b2": "€2.000 — €3.000",
    "budget.b3": "€3.000 — €4.000",
    "budget.b4": "Más de €4.000",
    "footer.tagline": "Expediciones de autor en los confines del mundo.",
    "footer.nav": "Navegación",
    "footer.contact": "Contacto",
    "footer.rights": "Todos los derechos reservados.",
    "legal.privacy": "Política de Privacidad",
    "legal.cookie": "Política de Cookies",
    "legal.preferences": "Preferencias de cookies",
    "cookie.text": "Usamos cookies técnicas necesarias para el funcionamiento del sitio y, solo con tu consentimiento, herramientas de estadística para entender cómo se utiliza. Puedes cambiar de opinión en cualquier momento.",
    "cookie.accept": "Aceptar",
    "cookie.reject": "Rechazar",
    "consent.pre": "He leído y acepto el tratamiento de mis datos como se describe en la",
    "consent.link": "Política de Privacidad",
    "past.title": "Gallery",
    "past.photos": "Fotos",
    "past.videos": "Vídeos",
    "past.audio": "Audio",
    "leader.media.title": "Galería y medios",
  },
};

const LanguageCtx = createContext({ lang: "it", setLang: () => {}, t: (k) => k });

export const DIFFICULTY = {
  it: { accessibile: "Accessibile", moderata: "Moderata", impegnativa: "Impegnativa" },
  en: { accessibile: "Easy-going", moderata: "Moderate", impegnativa: "Demanding" },
  es: { accessibile: "Accesible", moderata: "Moderada", impegnativa: "Exigente" },
};

export const LANGS = ["it", "en", "es"];

// La lingua è nell'URL: / = italiano, /en/... = inglese, /es/... = spagnolo
export function langFromPath(pathname = "/") {
  const seg = pathname.split("/")[1];
  return seg === "en" || seg === "es" ? seg : "it";
}

export function pathWithoutLang(pathname = "/") {
  return pathname.replace(/^\/(en|es)(?=\/|$)/, "") || "/";
}

export function LanguageProvider({ children }) {
  const lang = langFromPath(window.location.pathname);
  const setLang = (next) => {
    if (next === lang) return;
    const prefix = next === "it" ? "" : `/${next}`;
    const rest = pathWithoutLang(window.location.pathname);
    window.location.assign(`${prefix}${rest === "/" ? "/" : rest}${window.location.search}${window.location.hash}`);
  };
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (key) => (dict[lang] && dict[lang][key]) || dict.it[key] || key;
  return <LanguageCtx.Provider value={{ lang, setLang, t }}>{children}</LanguageCtx.Provider>;
}

export const useLang = () => useContext(LanguageCtx);
